import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from '../components/ui/sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F8F6]">
      {/* Grain overlay */}
      <div className="grain-overlay" />
      
      <Navbar />
      
      <main className="flex-1 pt-20 md:pt-24">
        {children}
      </main>
      
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};
